let _config = {
    api_base_url: '',
    apiUrl: '',
    resources_base_url: '',
    base_url: '',
    flag_env: '',
    paypal_client_id: '',
};

export function initConfig(config) {
    Object.assign(_config, config);
}

export function getConfig() {
    return _config;
}
